import DateInput from 'components/form/input/DateInput'
import React from 'react'

export default function FilterDataInput(name, label) {
    return {
        render: (props) => <DateInput
            sx={{ width: '100%' }}
            name={name}
            label={label}

            inputProps={{
                style: { textTransform: "uppercase" },



            }}
        />,
        compare: (value, row, filterValues) => {
            if (value) {                
                if (typeof row.dataInicio === 'string' || row.dataInicio instanceof String) {      
                    if(row.dataInicio.startsWith(value)){
                        return true
                    }
                }                 

                return false
            }
            return true
        }
    }
}
